import { makeSubmitData } from "api/makeApiRequestType/makeSubmitData";

type Params = {
	uid: string;
};

export const zoomUnlink = makeSubmitData<Params>("zoomUnlink");
